import { IRoute } from '../utils';
import Register from './register';
import SignIn from './sign-in';

const Route: IRoute = {
  path: '/login',
  label: 'Login',
  hidden: true,
  noAuth: true,
  hideToolbar: true,
  component: SignIn,

  routes: [
    {
      path: '/register',
      noAuth: true,
      component: Register,
      hideToolbar: true
    }
  ]
};

export default Route;
